export const STAGE5_PAID_CLAIM_ENABLED = process.env.REACT_APP_STAGE5_PAID_CLAIM_ENABLED === "true";
export const STAGE5_PAID_CLAIM_URL = process.env.REACT_APP_STAGE5_PAID_CLAIM_URL
  || "https://us-central1-invitations778.cloudfunctions.net/manageStage5PurchaseClaim";

export const callStage5PurchaseClaim = async ({ action, token }) => {
  const response = await fetch(STAGE5_PAID_CLAIM_URL, {
    method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ action, token }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(result.code || "STAGE5_PURCHASE_CLAIM_FAILED");
    error.code = result.code || `HTTP_${response.status}`;
    throw error;
  }
  return result;
};
